/**
 * SECURE STORAGE UTILITY
 * Prevents SecurityErrors or QuotaExceededErrors from crashing the app
 * when localStorage is blocked in sandboxed frames or third-party contexts.
 */

class SafeStorage {
  private memoryStore: Record<string, string> = {};

  getItem(key: string): string | null {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        return window.localStorage.getItem(key);
      }
    } catch (e) {
      console.warn("Storage read failed, using memory store", e);
    }
    return this.memoryStore[key] || null;
  }

  setItem(key: string, value: string): void {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.setItem(key, value);
        return;
      }
    } catch (e) {
      console.warn("Storage write failed, using memory store", e);
    }
    this.memoryStore[key] = value;
  }

  removeItem(key: string): void {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.removeItem(key);
        return;
      }
    } catch (e) {
      console.warn("Storage remove failed, using memory store", e);
    }
    delete this.memoryStore[key];
  }
}

export const safeStorage = new SafeStorage();
